(function () {
  const BREAKPOINT = 990; // adjust if your theme uses a different mobile breakpoint

  function updateSearchPlaceholder() {
    const inputs = document.querySelectorAll(
      'input[type="search"][placeholder-mobile][placeholder-desktop]'
    );
    const isMobile = window.innerWidth < BREAKPOINT;
    inputs.forEach((input) => {
      const mobilePlaceholder = input.getAttribute('placeholder-mobile');
      const desktopPlaceholder = input.getAttribute('placeholder-desktop');

      if (isMobile && mobilePlaceholder) {
        input.setAttribute('placeholder', mobilePlaceholder);
      } else if (!isMobile && desktopPlaceholder) {
        input.setAttribute('placeholder', desktopPlaceholder);
      }
    });
  }

  // Initial run
  updateSearchPlaceholder();

  // Update on resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSearchPlaceholder, 150);
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest(
      '[data-ele="search-icon-right"], [data-ele="search-box-overlay"]'
    );

    if (!trigger) return;

    const searchBox = document.querySelector('.header__top .header__search');
    const body = document.body;
    const predictiveSearch = searchBox.querySelector('predictive-search');
    const searchContent = predictiveSearch?.querySelector('.search__content');

    const isOpen = searchBox.classList.contains('search-box-open');

    if (isOpen) {
      // 🔴 Removing class (CLOSING)

      searchBox.classList.remove('search-box-open');
      body.classList.remove('search-open');

      if (predictiveSearch) {
        predictiveSearch.classList.remove('predictive-search-open');
      }

      if (searchContent) {
        searchContent.classList.add('hidden');
      }

    } else {
      // 🟢 Adding class (OPENING)

      searchBox.classList.add('search-box-open');
    }
  });


})();
